var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7619 25.5935C12.5085 25.5935 12.2552 25.5002 12.0552 25.3002L3.96187 17.2068C3.57521 16.8202 3.57521 16.1802 3.96187 15.7935L12.0552 7.70016C12.4419 7.31349 13.0819 7.31349 13.4685 7.70016C13.8552 8.08682 13.8552 8.72682 13.4685 9.11349L6.08187 16.5002L13.4685 23.8868C13.8552 24.2735 13.8552 24.9135 13.4685 25.3002C13.2819 25.5002 13.0152 25.5935 12.7619 25.5935Z",
    fill: "#E8E8DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3306 17.5H4.89062C4.34396 17.5 3.89062 17.0467 3.89062 16.5C3.89062 15.9533 4.34396 15.5 4.89062 15.5H27.3306C27.8773 15.5 28.3306 15.9533 28.3306 16.5C28.3306 17.0467 27.8773 17.5 27.3306 17.5Z",
    fill: "#E8E8DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7f838249a9e7335ca42dd022b0421f23.svg";
export { ForwardRef as ReactComponent };